import { render, staticRenderFns } from "./ClientAccountAssetTypesDetailsView.vue?vue&type=template&id=b13ddff0"
import script from "./ClientAccountAssetTypesDetailsView.vue?vue&type=script&lang=js"
export * from "./ClientAccountAssetTypesDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports